import { connect } from 'react-redux'
import { agentInfo } from '#/store/selectors/user'
import Logo from './Logo'

const mapStateToProps = (state: TopHap.StoreState) => ({ agent: agentInfo(state) })

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(Logo)
